import { atom } from 'jotai';

import { executionRunDetailQueryAtom } from '../_graphql/queryExecutionRunDetail';
import { automationsRoutes } from '../routes';

import { atomFromRoutePath } from '~/shared/state/location.state';

const $executionDetailRoute = atomFromRoutePath(
  automationsRoutes.executionDetail,
);

export const $executionRunId = atom((get) => {
  const params = get($executionDetailRoute) as {
    id?: string;
    executionId?: string;
  } | null;
  return params?.executionId ? String(params.executionId) : undefined;
});

export const $executionRunAutomationId = atom((get) => {
  const params = get($executionDetailRoute) as {
    id?: string;
    executionId?: string;
  } | null;
  return params?.id ? String(params.id) : undefined;
});

export const $remoteExecutionRunDetail = executionRunDetailQueryAtom((get) => {
  const executionId = get($executionRunId);
  return {
    variables: { id: executionId ?? '' },
    skip: !executionId,
  };
});
